import React from "react";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format, parse } from "date-fns";

const dayNameByIndex = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const StatCard = ({ label, value }) => (
  <Paper variant="outlined" elevation={0} sx={{ p: 1.5, textAlign: "center", bgcolor: "grey.50", borderRadius: 2 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography sx={{ fontWeight: 700, mt: 0.25 }}>{value}</Typography>
  </Paper>
);

const formatTimeRange = (startTime, endTime) => {
  const start = parse(String(startTime || "00:00"), "HH:mm", new Date());
  const end = parse(String(endTime || "00:00"), "HH:mm", new Date());
  return `${format(start, "h:mm a")} - ${format(end, "h:mm a")}`;
};

const BatchDetailModal = ({ batch, open, onClose, onViewFullBatch }) => {
  if (!batch) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        {batch.label}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={3}>
            <StatCard label="Students" value={batch.students} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <StatCard label="Instructor" value={batch.instructor} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <StatCard
              label="Time"
              value={formatTimeRange(
                batch.startTime ?? batch.time,
                batch.endTime ?? batch.time
              )}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <StatCard label="Days" value={batch.days.length} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>
            Progress: {batch.progress}%
          </Typography>
          <LinearProgress
            variant="determinate"
            value={batch.progress}
            sx={{
              height: 8,
              borderRadius: 2,
              bgcolor: "grey.200",
              "& .MuiLinearProgress-bar": {
                bgcolor: batch.color.text,
              },
            }}
          />
        </Box>

        <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
          {batch.days.map((d) => (
            <Chip
              key={d}
              size="small"
              label={dayNameByIndex[d]}
              sx={{ bgcolor: batch.color.bg, color: batch.color.text }}
            />
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={() => onViewFullBatch?.(batch)}>
          View full batch
        </Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BatchDetailModal;

